import { AppConfig } from "@oj-x/config"

export default AppConfig.get()
